import { useTranslation } from 'react-i18next';
import { Badge, BadgeProps } from '@anyui/core';
import { WarningReason, TikTokSpecialCampaignPostStatus } from '@anytag/graphql';
import { useGetPostWarningReasonStatusProps } from '../shared';

export interface TiktokSpecialPostStatusProps {
  className?: string;
  warningReason?: WarningReason;
  status: TikTokSpecialCampaignPostStatus;
}

export const TiktokSpecialPostStatus = ({ status, warningReason, className }: TiktokSpecialPostStatusProps) => {
  const { t } = useTranslation();
  const { getPostWarningReasonStatusProps } = useGetPostWarningReasonStatusProps();

  const hasReason = [TikTokSpecialCampaignPostStatus.WARNING].includes(status) && !!warningReason;
  const statusProps: BadgeProps = (() => {
    if (hasReason) {
      return getPostWarningReasonStatusProps(warningReason);
    } else {
      switch (status) {
        case TikTokSpecialCampaignPostStatus.APPROVED:
          return { children: t('Option.Approved'), color: 'green' };
        case TikTokSpecialCampaignPostStatus.EFFECTIVE:
        case TikTokSpecialCampaignPostStatus.WARNING_SOLVED:
          return { children: t('Option.Effective'), color: 'green' };
        case TikTokSpecialCampaignPostStatus.WARNING:
          return { children: t('Option.Warning'), color: 'red' };
        case TikTokSpecialCampaignPostStatus.INEFFECTIVE:
          return { children: t('Option.Ineffective'), color: 'zinc' };
        case TikTokSpecialCampaignPostStatus.JOINED:
          return { children: t('Option.Joined'), color: 'blue' };
        default:
          return { children: null, color: 'zinc' };
      }
    }
  })();

  return <Badge {...statusProps} className={className} />;
};
